const GivingTree = [
	'[Verse 1]',
	'All the leaves on the giving tree have fallen',
	'No shade to crawl in underneath',
	"I've got scars from a pocket knife",
	'Where you carved your heart into me',
	'',
	'[Chorus]',
	'If all you wanted was love',
	'Why would you use me up',
	'Cut me down, build a boat, and sail away',
	'When all I wanted to be was your giving tree',
	'Settle down, build a home, and make you happy?',
	'',
	'[Verse 2]',
	'I lie in the dead of night and I wonder',
	"Whose covers you're between",
	"And it's sad laying in his bed",
	'You feel hollow, so you crawl home back to me',
	'',
	'[Chorus]',
	'If all you wanted was love',
	'Why would you use me up',
	'Cut me down, build a boat, and sail away',
	'When all I wanted to be was your giving tree',
	'Settle down, build a home, and make you happy?',
	'',
	'[Bridge]',
	'Well, I see a trail that starts',
	'A line of broken hearts behind you',
	'That lead you back to me',
	'The once sad and lonely fool',
	'With nothing left but roots to show, oh oh',
	'',
	'[Chorus]',
	'If all you wanted was love',
	'Why would you use me up',
	'Cut me down, build a boat, and sail away',
	'When all I wanted to be was your giving tree',
	'Settle down, build a home, and make you happy?',
	'Settle down, build a home, and make you happy?',
];

export default GivingTree;
